import ProjectSession from "../../../../model2/project/project-session"
import {ProjectSystemTypeName} from "../../../../model2/project/types"
import {SystemStatus} from "../../../../gd/const/system-status"
import Project_updateSystemStatus from "../../../../model2/project/actions/update-system-status"

export default function unarchive_project(project:ProjectSession) {

    gd.modals.confirm.genericText('Unarchive '+project.name, 'Are you sure that you want to re-open this '+ProjectSystemTypeName[project.systemType], async ()=>{
        Project_updateSystemStatus(project, SystemStatus.IN_PROGRESS)
        gd.modal.hide()
    })
}